module.exports = __webpack_public_path__ + "static/success-banner-mobile-4c4b720fc8c0698cbc15d11518c16adf.jpg";